import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBySchedule',
  standalone: false
})
export class FilterBySchedulePipe implements PipeTransform {
  transform(conversations: any[], scheduleNumber: number): any[] {
    if (!conversations) return [];
    return conversations.filter(c => c.scheduleNumber === scheduleNumber);
  }
}